var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-image" }, [
    _c(
      "div",
      { staticClass: "card-inner" },
      [
        _vm._t("action"),
        _vm._v(" "),
        _c("div", { staticClass: "image-container" }, [_vm._t("image")], 2),
        _vm._v(" "),
        _c("div", { staticClass: "content-container" }, [_vm._t("default")], 2),
        _vm._v(" "),
        _vm._m(0),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "select-marker" }, [
      _c("i", { staticClass: "fa fa-check" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }